import HttpService from '@/api/HttpService';

export default {
  namespaced: true,
  actions: {
    async checkAvailability(_, { email, ssn }) {
      const payload = {};
      if (email) {
        payload.email = email;
      } else if (ssn) {
        payload.ssn = ssn;
      }
      try {
        const response = await HttpService.postV2('users/availability', payload);
        // API now returns { "available": true/false }
        return response.available;
      } catch (error) {
        console.error('Error checking availability:', error);
        throw error;
      }
    },
    provisionUser(_, { user, provideLogin = false, enableMfa = false }) {
      return HttpService.postV2(
        `users/provisioning?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
        user,
      );
    },
    updateUser(_, { userId, user, provideLogin = false, enableMfa = false }) {
      return HttpService.putV2(
        `users/${userId}?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
        user,
      );
    },
    saveUserProfile(_, { user, files, provideLogin = false, enableMfa = false }) {
      const {
        firstName,
        lastName,
        email,
        organizationName,
        alternateCompanyName,
        CRDnumber,
        primaryPhoneNum,
        secondaryPhoneNum,
        residentialAddress,
        mailingAddress,
      } = user;
      if (user.userType === 'ADVISOR') {
        const advisor = {
          firstName,
          lastName,
          email: typeof email === 'string' ? email.toLowerCase() : '',
          organizationName,
          alternateCompanyName,
          CRDnumber,
          primaryPhoneNum,
          secondaryPhoneNum,
          residentialAddress,
          mailingAddress,
        };
        return HttpService.post(
          `financial-user?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
          advisor,
        );
      }
      if (user.userType === 'INVESTOR'
        || user.userType === 'MINOR') {
        return HttpService.uploadFilesAndForm(
          `user/create-investor?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
          user,
          files,
        )
          .then(response => response)
          .catch((err) => {
            throw err;
          });
      }
      if (user.userType === 'INSTITUTIONAL_REPRESENTATIVE' || user.userType === 'READ_ONLY') {
        return HttpService.post(
          `institutional-representative?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
          user,
        )
          .then(response => response)
          .catch((err) => {
            throw err;
          });
      }
      const admin = {
        firstName,
        lastName,
        email: typeof email === 'string' ? email.toLowerCase() : '',
        organizationName,
        primaryPhoneNum,
        secondaryPhoneNum,
        residentialAddress,
        mailingAddress,
      };
      return HttpService.post('admin', admin);
    },
    updateUserProfile(_, { user, provideLogin = false, enableMfa = false }) {
      const {
        id,
        firstName,
        lastName,
        email,
        dateOfBirth,
        secondaryEmail,
        primaryPhoneNum,
        secondaryPhoneNum,
        mfaPhonePreference,
        residentialAddress,
        mailingAddress,
        socialSecurityNum,
        userType,
        hasBeenAllowedPOBox,
        hasBeenAllowedCommercialAddress,
        commercialAddressOverrideComment,
        commentCategories,
        comments,
      } = user;
      if (user.userType === 'INVESTOR' || user.userType === 'MINOR' || user.userType === 'INSTITUTIONAL_REPRESENTATIVE' || user.userType === 'READ_ONLY') {
        const investor = {
          id,
          firstName,
          lastName,
          email: typeof email === 'string' ? email.toLowerCase() : '',
          dateOfBirth,
          socialSecurityNum,
          secondaryEmail: typeof secondaryEmail === 'string' ? secondaryEmail.toLowerCase() : '',
          userType,
          primaryPhoneNum,
          secondaryPhoneNum,
          mfaPhonePreference,
          residentialAddress,
          mailingAddress,
          hasBeenAllowedPOBox,
          hasBeenAllowedCommercialAddress,
          commercialAddressOverrideComment,
          commentCategories,
          comments,
        };
        return HttpService.putV2(
          `users/${id}/profile?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
          investor,
        )
        .then(response => response)
        .catch((err) => {
          throw err;
        });
      }
      return false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/userCreationByAdmin.js